module.exports = __webpack_public_path__ + "img/venueone-fdkhtime.ab0f646a.png";